import axios from "axios";

import pagination from "../../pagination";
import filterable from "../../filterable";
import fetchable from "../../fetchable";
import { boundaryWKT2Bounds } from "@/carto-node/models/visualization"
import { cartoTileRe } from "@/carto-node/models/visualization"

export function transVector(ddeMap) {
  const url = ddeMap.layerServiceInfo.url
  if (url.includes('visualization_tiles')) {
    const base_url = url.split('/visualization_tiles/')[0]
    const id = url.split('/visualization_tiles/')[1].split('/')[0]
    return {
      id,
      name: ddeMap.name,
      privacy: 'PUBLIC',
      updated_at: ddeMap.updateTime,
      showBaseLayer: ddeMap.layerServiceInfo.showBaseMap,
      permission: {
        owner: {
          base_url,
          username: base_url.split('/user/')[1]
        }
      },
      fields: ddeMap.fields
    }
  } else if (url.includes('api/v1/map/named/tpl_')) {
    if (url.match(cartoTileRe)) {
      const id = cartoTileRe.exec(url)[1].replaceAll('_', '-');
      const base_url = url.split('/api/v1/map/named')[0];
      return {
        id,
        name: ddeMap.name,
        privacy: 'PUBLIC',
        updated_at: ddeMap.updateTime,
        showBaseLayer: ddeMap.layerServiceInfo.showBaseMap,
        permission: {
          owner: {
            base_url,
            username: base_url.split('/user/')[1]
          }
        },
        fields: ddeMap.fields
      }
    }
  }
  ddeMap.bounds = boundaryWKT2Bounds(ddeMap.boundaryWKT)
  return ddeMap
}

export default {
  namespaced: true,
  modules: {
    pagination,
    filterable,
    fetchable,
  },
  state: {
    list: [],
    addedList: []
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    updateVisualization(state, { visualizationId, visualizationAttributes }) {
      const vis = state.list.find((vis) => vis.id === visualizationId);
    
      if (vis) {
        Object.assign(vis, visualizationAttributes);
      }
    },
    addToEarth(state, visId) {
      const map = state.list.find(m => m.id === visId)
      if (map) {
        const cloneMap = JSON.parse(JSON.stringify(map))
        cloneMap.addedTime = Date.now()
        cloneMap.mapType = 'MapItem'
        cloneMap.module = 'selectedMaps'
        state.addedList.push(cloneMap)
      }
    },
    removeFromEarth(state, visId) {
      const idx = state.addedList.findIndex(m => m.id === visId)
      if (idx >= 0) {
        state.addedList.splice(idx,1)
      }
    }
  },
  actions: {
    async fetchList({ state, commit }) {
      if (state.fetchable.isFetching) return;
      commit('fetchable/setFetching', true)
      try {
        const response = await axios.post(`https://alpha.deep-time.org/v1.0/api/data-central/atom/list/public?official=2&keyword=${state.filterable.filterKeyword}&datasetId=238&pageSize=${state.pagination.perPage}&page=${state.pagination.page - 1}`);
        const { list, total } = response.data.data;
        const transList = list.map(transVector);
        const existIds = state.addedList.map(m => m.id);      
        commit("setList", transList.map(m => ({ 
          ...m, 
          added_to_map: existIds.includes(m.id), 
          visible: true,
          legend: (m.fields || []).find(f => f.fieldName === 'legend')?.description,
          show_license: (m.fields || []).find(f => f.fieldName === 'show_license')?.description,
        })));
        commit("pagination/setTotalEntities", total);
      } catch (e) {
        commit("fetchable/setError", e);
      } finally {
        commit('fetchable/setFetching', false);
      }
    },

    async fetchPage(context, payload) {
      context.commit("pagination/setPage", payload.page);
      await context.dispatch("fetchList");
    },

    async fetchFilter(context, payload) {
      context.commit("filterable/setFilterType", payload.filterType);
      context.commit("filterable/setFilterKeyword", payload.filterKeyword);
      await context.dispatch("fetchList");
    },

    addToEarth({ state, commit }, visId) {
      commit("addToEarth", visId)
      const updateAttrs = {
            visualizationId: visId,
            visualizationAttributes: { added_to_map: true },
      };
      commit("updateVisualization", updateAttrs);
      const vis = state.addedList.find( m => m.id === visId)
      if (vis) {
        commit("maps/addToOrderList", vis, {root: true})
      }
    },

    removeFromEarth({ commit }, visId) {
      commit("removeFromEarth", visId)
      const updateAttrs = {
            visualizationId: visId,
            visualizationAttributes: { added_to_map: false },
      };
      commit("updateVisualization", updateAttrs);
      commit("maps/removeFromOrderList", visId, { root: true })
    }
  }
}